import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';

export const BluePillButton = styled(Button)(() => ({
  borderRadius: 18,
  paddingLeft: 30,
  paddingRight: 30,
  color: '#ffffff',
  backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-500'),
  '&:hover': {
    backgroundColor: getComputedStyle(document.documentElement).getPropertyValue('--primary-400'),
  },
  '&:disabled': {
    color: '#ccc',
    opacity: 0.4,
  },
}));
